import mitt from 'mitt';

if (!window.__CHASER_EMITTER__) {
  window.__CHASER_EMITTER__ = mitt();
}

const emitter = window.__CHASER_EMITTER__;

export default emitter;
